import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { MotionConfig } from 'framer-motion';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <MotionConfig reducedMotion="never">
      <App />
    </MotionConfig>

);
